import React, { Component } from 'react';
import Form from 'react-bootstrap/lib/Form';
import { FieldArray } from 'formik';
import { Button } from '../../Button';
import { ButtonLoader } from '../../ButtonLoader';
import { Select } from '../../Select';
import { ThematicAreaDropdownOption, DefaultOffice, DistrictDropdownOption } from '../../../utils/enums';
import { AttachmentItem } from '../AttachmentItem';
import { InitiativeMode } from '../../../utils/enums';
// import ReCaptcha from '../../ReCaptchaWrapper';

export class ConsultationProposalInitiative extends Component {
	constructor(props) {
		super(props);
		this.captcha = null;
	}

	verify = async () => await this.captcha.verify();

	render() {
		const props = this.props;
		return (
			<div className="box margin-top-20">
				<div className="container initiative">
					<div className="initiative-column--70">
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="title" className="field__label">
									Temat/tytuł
								</Form.Label>
								<Form.Control
									id="title"
									name="title"
									value={props.title}
									onChange={props.onChange}
									className="field__input"
									onBlur={props.onBlur}
									placeholder="Temat/tytuł"
									title="Wpisz temat/tytuł"
									isInvalid={!!props.errors.title}
									autocomplete="off"
								/>
							</div>
							{typeof props.errors.title === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.title}
								</Form.Control.Feedback>
							)}
						</Form.Group>
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="content" className="field__label">
									Treść
								</Form.Label>
								<Form.Control
									as="textarea"
									rows="10"
									id="content"
									name="content"
									value={props.content}
									onChange={props.onChange}
									className="field__textarea"
									onBlur={props.onBlur}
									placeholder="Treść"
									title="Wpisz treść inicjatywy"
									isInvalid={!!props.errors.content}
									autocomplete="off"
								/>
							</div>
							{typeof props.errors.content === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.content}
								</Form.Control.Feedback>
							)}
						</Form.Group>
					</div>
					<aside className="initiative-column--30">
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="thematicAreaId" className="field__label">
									Kategoria
								</Form.Label>
								<Select
									id="thematicAreaId"
									name="thematicAreaId"
									options={[
										{
											value: ThematicAreaDropdownOption.NotSetted,
											text: '[Wybierz]'
										},
										...props.thematicAreas
									]}
									value={props.thematicAreaId}
									onSelect={(option) => props.setFieldValue('thematicAreaId', option.value)}
								/>
							</div>
							{typeof props.errors.thematicAreaId === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.thematicAreaId}
								</Form.Control.Feedback>
							)}
						</Form.Group>
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="districtId" className="field__label">
									Obszar
								</Form.Label>
								<Select
									id="districtId"
									name="districtId"
									options={[
										{
											value: DistrictDropdownOption.NotSetted,
											text: '[Wybierz]'
										},
										...props.districts
									]}
									value={props.districtId}
									onSelect={(option) => props.setFieldValue('districtId', option.value)}
								/>
							</div>
							{typeof props.errors.districtId === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.districtId}
								</Form.Control.Feedback>
							)}
						</Form.Group>
					</aside>
				</div>
				<div className="buttons margin-top-20" />
				<FieldArray
					id="attachments"
					name="attachments"
					render={(arrayHelpers) => (
						<AttachmentItem
							maxSize={props.attachmentConfiguration.maxAttachmentSize * 1024 * 1024}
							disabled={false}
							items={props.attachments}
							removeable={true}
							baseUrl={'/api/attachments/initiative-attachement'}
							uploadFile={props.uploadFile}
							onAddItem={arrayHelpers.push}
							onRemoveItem={arrayHelpers.remove}
						/>
					)}
				/>
				{typeof props.errors.attachments === 'string' && (
					<Form.Control.Feedback type="invalid" className="field--invalid">
						{props.errors.attachments}
					</Form.Control.Feedback>
				)}

				{!props.isAuth && (
					<div className="buttons margin-top-20">
						<Form.Group>
							<div className="field field--input">
								<Form.Label htmlFor="replyTo" className="field__label">
									Adres e-mail
								</Form.Label>
								<Form.Control
									id="replyTo"
									name="replyTo"
									value={props.replyTo}
									onChange={props.onChange}
									className="field__input"
									onBlur={props.onBlur}
									placeholder="Adres e-mail"
									title="Wpisz adres e-mail"
									isInvalid={!!props.errors.replyTo}
								/>
							</div>
							{typeof props.errors.replyTo === 'string' && (
								<Form.Control.Feedback type="invalid" className="field--invalid">
									{props.errors.replyTo}
								</Form.Control.Feedback>
							)}
						</Form.Group>
					</div>
				)}
				{
					/* Nie przechodzi walidacji WCAG2.1 */
					// <div className="buttons margin-top-20">
					// <ReCaptcha ref={(ref) => (this.captcha = ref)} service={props.reCaptchaConfig.reCaptchaKey} />
					// </div>
				}
				{(props.isAuth || props.mode === InitiativeMode.Enabled) && (
					<div className="buttons margin-top-20">
						<ButtonLoader
							type="submit"
							variant="danger"
							disabled={!props.verified || !props.isValid || props.isInitiativeCreating}
							text={'Wyślij'}
							executingText={'Wysyłanie'}
							isExecuting={props.isInitiativeCreating}
						/>
					</div>
				)}
				{!props.isAuth &&
				props.mode !== InitiativeMode.Enabled && (
					<div className="buttons margin-top-20">
						<Button type="submit" variant="danger" disabled={true}>
							Wyślij
						</Button>
						<Form.Control.Feedback type="invalid" className="field--invalid">
							Wymaga zalogowania
						</Form.Control.Feedback>
					</div>
				)}
			</div>
		);
	}
}

ConsultationProposalInitiative.defaultProps = {
	title: '',
	content: '',
	replyTo: '',
	attachments: [],
	attachmentConfiguration: {
		maxAttachmentQuantity: 3,
		maxAttachmentSize: 5,
		maxAllAttachmentsSize: 15
	},
	cost: 0,
	thematicAreaId: ThematicAreaDropdownOption.NotSetted,
	districtId: DistrictDropdownOption.NotSetted,
	officeId: DefaultOffice.NotSetted,
	thematicAreas: [],
	districts: [],
	isAuth: false,
	reCaptchaConfig: {
		reCaptchaKey: ''
	},
	isInitiativeCreating: false,
	onSubmit: Function.prototype,
	setFieldValue: Function.prototype
};

// recaptcha key - 6LeO5o4UAAAAACtqupU5rIOHQqQDGFVEUyOXCWO7
